import { render, staticRenderFns } from "./_online_shop.vue?vue&type=template&id=26752b06&"
import script from "./_online_shop.vue?vue&type=script&lang=js&"
export * from "./_online_shop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports